import { animations } from 'theme';

export const styles = {
  innerCardContent: {
    //*vertical padding in px - see the note in DesktopTotalImpressionCard.styles.ts (a % padding is width-relative and breaks row alignment)
    padding: '12px 4%',
    borderRadius: 'inherit',
    ...animations.appearanceEffect,
    '@media (min-width: 2250px)': {
      padding: '12px 1%',
    },
  },
  upperRow: {
    borderBottom: '1px solid #e6e9ed',
  },
};
